var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9245 0C22.2084 1.94507 21.4255 3.84733 20.395 5.19494C19.2913 6.63856 17.3894 7.75713 15.5504 7.69987C15.216 5.83809 16.0773 3.9231 17.1208 2.63217C18.2699 1.20995 20.24 0.118566 21.9245 0ZM27.4589 27.357C28.4088 25.8851 28.7625 25.1418 29.5 23.4756C24.1405 21.4119 23.278 13.6982 28.582 10.7375C26.9622 8.68426 24.69 7.49339 22.5462 7.49339C20.998 7.49339 19.9378 7.90194 18.9742 8.27323C18.1716 8.58247 17.4362 8.86587 16.5417 8.86587C15.576 8.86587 14.7204 8.55521 13.8241 8.22974C12.8379 7.87168 11.8024 7.49571 10.5168 7.49571C8.10609 7.49571 5.54271 8.98675 3.91838 11.5339C1.63319 15.1192 2.02096 21.8642 5.72722 27.6121C7.05348 29.667 8.82429 31.9782 11.1396 31.9996C12.0979 32.0085 12.7362 31.7186 13.4269 31.4049C14.2188 31.0452 15.0796 30.6542 16.5707 30.6462C18.07 30.6385 18.9168 31.0334 19.6982 31.3979C20.372 31.7122 20.9971 32.0038 21.9501 31.995C24.2654 31.9718 26.1338 29.4137 27.4589 27.357Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.0676e62f6eb3c55de873770f1cc569ef.svg";
export { ForwardRef as ReactComponent };